// extracted by mini-css-extract-plugin
export default {"sendButton":"FeedbackDialog_sendButton__qfRYT","labelFeedback":"FeedbackDialog_labelFeedback__y9kWf"};